import script from "./FundTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FundTable.vue?vue&type=script&setup=true&lang=js"

import "./FundTable.vue?vue&type=style&index=0&id=ffb82be4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffb82be4"]])

export default __exports__